function problemDetailMessage(error: unknown): string | undefined {
  if (typeof error !== 'object' || error === null) {
    return undefined;
  }

  if ('detail' in error && typeof error.detail === 'string' && error.detail.trim()) {
    return error.detail.trim();
  }

  if ('title' in error && typeof error.title === 'string' && error.title.trim()) {
    return error.title.trim();
  }

  return undefined;
}

export function getProblemDetailMessage(error: unknown): string | undefined {
  const detail = problemDetailMessage(error);
  if (detail) {
    return detail;
  }

  return error instanceof Error && 'cause' in error ? problemDetailMessage(error.cause) : undefined;
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  const detail = getProblemDetailMessage(error);
  if (detail) {
    return detail;
  }

  if (error instanceof Error) {
    if (error.message.trim()) {
      return error.message.trim();
    }
  }

  return fallback;
}
